import { resetForm, loadForm } from '../State/form';
import { setSupplier } from '../State/supplier';

export default (props) => async (dispatch) => {

  const { supplier } = props;

  if (supplier) {
    dispatch(setSupplier(supplier));
    
    // Extract only the form fields, excluding relationships
    const formData = {
      company_name: supplier.company_name,
      trading_name: supplier.trading_name,
      company_registration: supplier.company_registration,
      vat_number: supplier.vat_number,
      email: supplier.email,
      phone: supplier.phone,
      website: supplier.website,
      address_line_1: supplier.address_line_1,
      address_line_2: supplier.address_line_2,
      city: supplier.city,
      county: supplier.county,
      postcode: supplier.postcode,
      country: supplier.country,
      payment_terms: supplier.payment_terms,
      default_lead_time_days: supplier.default_lead_time_days,
      default_currency: supplier.default_currency,
      default_tax_rate: supplier.default_tax_rate,
      credit_limit: supplier.credit_limit,
      account_number: supplier.account_number,
      notes: supplier.notes,
      active: supplier.active,
    };
    
    dispatch(loadForm(formData));
  } else {
    dispatch(resetForm());
    dispatch(setSupplier(null));
  }
}
